import { render, staticRenderFns } from "./CreateGroupConversationModalNew.vue?vue&type=template&id=30fbfd60"
import script from "./CreateGroupConversationModalNew.vue?vue&type=script&lang=ts"
export * from "./CreateGroupConversationModalNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30fbfd60')) {
      api.createRecord('30fbfd60', component.options)
    } else {
      api.reload('30fbfd60', component.options)
    }
    module.hot.accept("./CreateGroupConversationModalNew.vue?vue&type=template&id=30fbfd60", function () {
      api.rerender('30fbfd60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/CreateGroupConversationModalNew.vue"
export default component.exports